import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { serverURL } from "../components/networking";

export default function ConfirmPage() {
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    return (
        <div>
            <div className="login-left">
                <div>
                    <img src="/korotuIconWhite.svg" alt="Korotu Tech. Icon" />
                    <h4>Korotu</h4>
                </div>
                <h1>CarbonCruise</h1>
            </div>

            <div className="login-right">
                {
                    <ConfirmRegisterForm
                        navigate={navigate}
                        setErrorMessage={setErrorMessage}
                    />
                }
                <h5 className="error-message" style={{ color: "white" }}>
                    {errorMessage}
                </h5>
            </div>
        </div>
    );
}

function ConfirmRegisterForm({ navigate, setErrorMessage }) {
    const [code, setCode] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [email, setEmail] = useState("");

    function confirmEmail(code, email, password, passwordVerify) {
        if (
            password === passwordVerify &&
            password !== "" &&
            code !== "" &&
            email !== ""
        ) {
            let csrf = document.cookie.replace(
                /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
                "$1",
            );
            setErrorMessage("");
            axios
                .post(
                    serverURL + "/api/user/confirm/",
                    { email: email, password: password, code: code },
                    {
                        withCredentials: true,
                        headers: {
                            "X-CSRFToken": csrf,
                        },
                    },
                )
                .then(function (response) {
                    console.log(response);
                    navigate("/");
                })
                .catch(function (error) {
                    console.log(error);
                    console.log(error.response);
                    setErrorMessage(error.response.data.message);
                });
        } else if (password !== passwordVerify) {
            setErrorMessage("Passwords don't match!");
        } else {
            setErrorMessage("No fields may be left blank!");
        }
    }

    return (
        <>
            <h2>Confirm Email</h2>
            <h5>
                You should have recieved a code sent to the email you
                registered.
            </h5>
            <p>Confirm Your Email: </p>{" "}
            <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <p>Code: </p>{" "}
            <input
                type="code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
            />
            <p>Password: </p>{" "}
            <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <p>Confirm Password:</p>{" "}
            <input
                type="password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
            />
            <button
                type="button"
                onClick={() => confirmEmail(code, email, password, password2)}
            >
                Submit
            </button>
            <button
                type="button"
                onClick={() => {
                    setErrorMessage("");
                    navigate("/");
                }}
            >
                Return to Login
            </button>
        </>
    );
}
